import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { destroy } from 'redux-form';

import { sendContactRequest } from 'modules/Contact/actions-rxjs/sendContactRequest';
import ContactView from './ContactView';

const mapStateToProps = state => ({
  translations: state.i18n.translations[state.i18n.lang],
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      destroy,
      sendContactRequest,
    },
    dispatch,
  );

const ContactContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ContactView);

export default ContactContainer;
